import { Box, Button, Text } from "@mantine/core";
import React from "react";
import { useNavigate } from "react-router";

function Page404() {
    const navigate = useNavigate();

    return (
        <Box style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <Text size="90px">404</Text>
            <Text size="20px" mt={16}>🫵😂</Text>
            <Button w={200} h={50} fz={18} mt={64} onClick={(() => navigate("/"))}>Go Home</Button>
        </Box>
    )
}

export default Page404